import { createRef, forwardRef } from 'react';
import AsyncSelect from 'react-select/async';

import { getAllCustomers } from '../../api/customers';

import './select.scss';

const CustomerSelect = ({
  className,
  label,
  value,
  doctor,
  valid,
  validationText = 'This field is required!',
  selectRef,
  onChange,
}) => {
  className += ' single-select';
  selectRef = selectRef || createRef();

  const errorClass = valid ? '' : 'error';

  const promiseOptions = (inputValue) =>
    new Promise((resolve) => {
      setTimeout(async () => {
        const result = await getAllCustomers(1, `&search=${inputValue}`, 20);
        resolve(
          result.items.map((d) => ({
            id: d.id,
            value: `${d.firstName} ${d.lastName}`,
            label: `${d.firstName} ${d.lastName}`,
            phone: d.phone,
            email: d.email,
            city: d.city,
            address: d.address,
            firstName: d.firstName,
            lastName: d.lastName,
            dateOfBirth: d.dateOfBirth,
            carteVitale: d.carteVitale,
            center: d.center,
            fund: d.fund,
            regime: d.regime,
          })),
        );
      }, 1000);
    });

  return (
    <div className={`input-group ${errorClass}`}>
      <label>{label}</label>

      <AsyncSelect
        cacheOptions
        value={value}
        loadOptions={promiseOptions}
        defaultOptions
        placeholder="Enter customer's first name, last name or email"
        ref={selectRef}
        className={className}
        classNamePrefix="select"
        onChange={onChange}
      />
      {!valid && <span className="error">{validationText}</span>}
    </div>
  );
};

export default forwardRef(function customerSelect(props, ref) {
  return <CustomerSelect selectRef={ref} {...props} />;
});
